// extracted by mini-css-extract-plugin
module.exports = {"container":"az_J5c","section":"az_K5c","ratingsSection":"az_L5c","--longGap":"az_M5c","average":"az_N5c","--fontBody":"az_O5c","rating":"az_P5c"};